import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import BillingPage from "./billingPage";
import xhrService from "../../utils/xhrService";
import striepApi from "../../utils/api/stripeAPI";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const StripeContainer = ({ email, name }) => {
    const [clientSecret, setClientSecret] = useState("");
    const [clientId, setClientId] = useState(null);
    const freeTrialUserData = localStorage.getItem('freeTrialUserData');
    const freeTrialUserParsedData = JSON.parse(freeTrialUserData);

    useEffect(() => {
        striepApi.createCustomer({ email, name }).then((response) => {
            localStorage.setItem('freeTrialUserData', JSON.stringify({
                ...freeTrialUserParsedData,
                customerId: response.customerId,
            }));
            setClientSecret(response.clientSecret);
            setClientId(response.customerId);
        })
    }, [email, name]);

    const appearance = { theme: "stripe" };
    const options = { clientSecret, appearance };

    if (!clientSecret) return <div>Loading...</div>;

    if (!!clientId) {
        xhrService.put("/api/leadGen", { id: Number(freeTrialUserParsedData.leadGenId), customerId: clientId }).then(() => {
            console.log("Client ID updated successfully");
        }).catch((error) => {
            console.error("Error updating Client ID:", error);
        });
    };

    return (
        <Elements stripe={stripePromise} options={options}>
            <BillingPage />
        </Elements>
    );
};

export default StripeContainer;
